export interface ChangelogEntry {
  version: string;
  title: string;
  date: string;
  type: "feature" | "improvement" | "fix";
}

export const CHANGELOG_ENTRIES: ChangelogEntry[] = [
  {
    version: "1.5",
    title: "canvas auto-save",
    date: "2024-01-15",
    type: "feature",
  },
  {
    version: "1.4",
    title: "bulk csv import",
    date: "2024-01-10",
    type: "feature",
  },
  {
    version: "1.3",
    title: "ai scoring improvements",
    date: "2024-01-05",
    type: "improvement",
  },
  {
    version: "1.2",
    title: "workspace permissions",
    date: "2024-01-02",
    type: "feature",
  },
  {
    version: "1.1",
    title: "product search filters",
    date: "2023-12-28",
    type: "improvement",
  },
];

export const DOCS_URL = "https://docs.alana.shopping";
export const CHANGELOG_URL = "https://docs.alana.shopping/changelog";
export const SUPPORT_EMAIL = "support@alana.shopping";
